export default {
  title: {
    jobPosterManagement: 'Job Poster Management',
    jobPosterAmbassadorUpload: 'Upload Ambassador',
    jobPosterAmbassadorAdd: 'Add ambassador',
    jobPosterAmbassadorEdit: 'Edit ambassador'
  },
  label: {
    companyName: 'Company Name',
    on: 'ON',
    off: 'OFF',
    add: 'Add',
    posterSize: 'Poster Size',
    shareCoverImage: 'Share Cover Image',
    uploadFile: 'Upload',
    imgRecommended: 'Recommended size: {recommendedSize}',
    sameAsVideoSize: 'same as video size',
    fieldValue: 'Field Value',
    operation: 'Operation',
    jobName: 'Job Name',
    city: 'City',
    font: 'Font',
    size: 'Size',
    qrCodeSize: 'QR Code Size',
    qrCodePosition: 'QR Code Position',
    qrCodeDisplay: 'QR Code Display',
    roundedCorners: 'Rounded Corners',
    haveLogo: 'Have Logo',
    yes: 'Yes',
    no: 'No',
    save: 'Save',
    preview: 'Preview',
    previewPicture: 'Preview Picture',
    previewVideo: 'Preview Video',
    acceptImageType: '*Please upload jpg/jpeg/png images only.',
    acceptImageSize: '*Images should not be larger than {imageMaxSize}MB.',
    isEnable: 'Is Enabled',
    acceptVideoType: '*Please upload mp4 video only.',
    acceptVideoSize: '*Video should not be longer than {videoMaxDuration} seconds，and not larger than {videoMaxSize}MB',
    posterType: 'Poster Format',
    posterTitle: 'Poster Title',
    imgPoster: ' Image',
    imageSize: 'Image Size',
    videoPoster: ' Video',
    posterVideo: 'Poster Video',
    currentVideoSize: 'Current video size',
    videoTopImage: 'Watermark On Video Top',
    videoBottomImage: 'Watermark On Video Bottom',
    videoBindImage: 'Video End Image',
    align: {
      center: 'center align'
    },
    distinct: 'District',
    address: 'Address',
    email: 'Email',
    phone: 'Phone',
    name: 'Name',
    excelInput: 'EXCEL File: ',
    ambassadorStatus: 'Status',
    addAmbassador: 'Add Ambassador',
    editAmbassador: 'Edit Ambassador',
    companyJobPoster: 'Job Poster(s)',
    ambassadorJobPoster: 'My Poster(s)',
    customJobPoster: 'Add new Poster',
    instructionsJobPoster: 'Instruction Poster(s)',
    jobPosterShowType: 'Poster Type',
    followTheme: 'Align with Theme Font'
  },
  message: {
    wrongImageType: 'Please upload an image file.',
    wrongImageSize: 'Please upload an image file no larger than {size}MB.',
    wrongVideoType: 'Please upload an mp4 video file.',
    wrongVideoSize: 'Please upload an mp4 video no larger than {size}MB and no longer than {duration} seconds',
    bindImageTip: 'Watermark image recommended to be same width with video and bind image recommended to be same width and height with video',
    uploading: 'Uploading……',
    compressing: 'Compressing……',
    generating: 'Generating……',
    uploadSuccess: 'Successfully uploaded',
    uploadFailed: 'Upload failed',
    operateFailed: 'Operate failed, please retry',
    noPosterTitle: 'Please input the job poster title, no more than 60 words',
    noPosterVideo: 'Please upload the job poster video.',
    noPosterBgImage: 'Please upload the job poster image.',
    noPosterShareImage: 'Please upload the share cover image',
    // uploadToCdnError: 'Upload the images to server fail，please try again',
    uploadToCdnError: 'Fail to upload images, please try again',
    posterBgSizeError: 'The poster width and height cannot be 0',
    posterSaveError: 'Fail to save, please try again',
    posterSaveSuccess: 'Successfully saved',
    uploadTip: 'You can only upload a excel file',
    uploadError: 'Upload failed, please upload again',
    uploadAmbassadorSuccess: 'Upload success {successCount} count, fail {failCount} count',
    missEmailOrPhone: 'Fill in at least one email address or one mobile phone',
    deleteAmbassadorPosterSuccess: 'Successfully deleted!',
    deleteAmbassadorPosterFail: 'Error occurs, please try again.'
  },
  btn: {
    selectFile: 'Browse',
    upload: 'Upload Ambassador',
    downloadTemplate: 'Download Template',
    fleshData: 'Refresh',
    cancelUpload: 'Cancel',
    ConfirmUpload: 'Confirm',
    addAmbassador: 'Add Ambassador',
    editImgJobPoster: 'Upload image',
    editVideoJobPoster: 'Upload video'
  },
  placeholder: {
    name: 'Please input name',
    phone: 'Please input phone',
    email: 'Please input email'
  },
  jobPosterShowType: {
    COMMON: 'Company Poster',
    CUSTOM: 'Ambassador Poster',
    INSTRUCTIONS: 'Instruction Poster'
  }
}
